import { IsEnum } from 'class-validator';
import { LogLevel } from './log-level.js';

export class LogLevelDto
{
    @IsEnum(LogLevel)
    level!: LogLevel;
}